// extracted by mini-css-extract-plugin
module.exports = {"scrollBtn":"scroll-btn_scrollBtn__yMS7_","btn":"scroll-btn_btn__OXSPz"};